import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><table parentName="section">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Update Action`}</th>
            <th parentName="tr" {...{
              "align": "center"
            }}>{`Cart`}</th>
            <th parentName="tr" {...{
              "align": "center"
            }}>{`direct Order`}</th>
            <th parentName="tr" {...{
              "align": "center"
            }}>{`OrderEdit`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setKey`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-key"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomerEmail`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customer-email"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-customer-email"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-customer-email"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingAddress`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-shipping-address"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-shipping-address"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shipping-address"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setBillingAddress`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-billing-address"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-billing-address"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-billing-address"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCountry`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-country"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-country"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`recalculate`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#recalculate"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingMethod`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-shippingmethod"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shippingmethod"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomShippingMethod`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-custom-shippingmethod"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-custom-shippingmethod"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`addDiscountCode`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#add-discountcode"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#add-discountcode"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`removeDiscountCode`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#remove-discountcode"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#remove-discountcode"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomerId`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customer-id"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-customer-id"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customer-email"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setAnonymousId`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-anonymous-id"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomerGroup`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customer-group"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-customer-group"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`addPayment`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#add-payment"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#add-payment"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#add-payment"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`removePayment`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#remove-payment"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#remove-payment"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#remove-payment"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingMethodTaxRate`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-shippingmethod-taxrate"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shippingmethod-taxrate"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingMethodTaxAmount`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-shippingmethod-taxamount"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shippingmethod-taxamount"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCartTotalTax`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-cart-total-tax"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setOrderTotalTax`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-ordertotaltax"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`changeTaxMode`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#change-taxmode"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#change-taxmode"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLocale`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-locale"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-locale"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-locale"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`changeTaxRoundingMode`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#change-tax-roundingmode"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#change-tax-roundingmode"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingRateInput`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-shippingrateinput"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shippingrateinput"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`changeTaxCalculationMode`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#change-taxcalculationmode"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#change-taxcalculationmode"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`addShoppingList`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#add-shopping-list"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#add-shopping-list"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setDeleteDaysAfterLastModification`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-deletedaysafterlastmodification"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`addItemShippingAddress`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#add-itemshippingaddress"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#add-itemshippingaddress"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#add-itemshippingaddress"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`removeItemShippingAddress`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#remove-itemshippingaddress"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#remove-itemshippingaddress"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#remove-itemshippingaddress"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`updateItemShippingAddress`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#update-itemshippingaddress"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#update-itemshippingaddress"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#update-itemshippingaddress"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingAddressAndShippingMethod`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shippingaddressandshippingmethod"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingAddressAndCustomShippingMethod`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shippingaddressandcustomshippingmethod"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`LineItem update actions`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`applyDeltaToLineItemShippingDetailsTargets`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#apply-deltatolineitemshippingdetailstargets"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemShippingDetails`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitemshippingdetails"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-lineitemshippingdetails"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitemshippingdetails"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`addLineItem`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#add-lineitem"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#add-lineitem"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`removeLineItem`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#remove-lineitem"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#remove-lineitem"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`changeLineItemQuantity`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#change-lineitem-quantity"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#change-lineitem-quantity"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitem-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-lineitem-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitem-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitem-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-lineitem-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitem-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingAddressCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-shipping-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-shipping-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shipping-address-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setShippingAddressCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-shipping-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-shipping-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-shipping-address-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setBillingAddressCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-billing-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-billing-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-billing-address-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setBillingAddressCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-billing-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-billing-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-billing-address-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setItemShippingAddressCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-itemshipping-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-itemshipping-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-itemshipping-address-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setItemShippingAddressCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-itemshipping-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-itemshipping-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-itemshipping-address-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setDeliveryAddressCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-delivery-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-delivery-address-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-delivery-address-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setDeliveryAddressCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-delivery-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-delivery-address-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-delivery-address-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setDeliveryCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-delivery-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-delivery-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setDeliveryCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-delivery-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-delivery-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setParcelCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-parcel-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-parcel-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setParcelCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-parcel-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-parcel-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setReturnItemCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-returnitem-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-returnitem-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setReturnItemCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-returnitem-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-returnitem-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemTaxRate`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitem-taxrate"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitem-taxrate"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemTaxAmount`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitem-taxamount"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitem-taxamount"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemTotalPrice`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitem-totalprice"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitem-totalprice"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemPrice`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitem-price"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitem-price"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setLineItemDistributionChannel`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-lineitem-distributionchannel"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-lineitem-distributionchannel"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`CustomLineItem update actions`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
            <td parentName="tr" {...{
              "align": "center"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`applyDeltaToCustomLineItemShippingDetailsTargets`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#apply-deltatocustomlineitemshippingdetailstargets"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomLineItemShippingDetails`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customlineitemshippingdetails"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`addCustomLineItem`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#add-customlineitem"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#add-customlineitem"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`removeCustomLineItem`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#remove-customlineitem"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#remove-customlineitem"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomLineItemCustomType`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customlineitem-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-customlineitem-custom-type"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-customlineitem-custom-type"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomLineItemCustomField`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customlineitem-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/orders#set-customlineitem-customfield"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-customlineitem-customfield"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomLineItemTaxAmount`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customlineitem-taxamount"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-customlineitem-taxamount"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`setCustomLineItemTaxRate`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#set-customlineitem-taxrate"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#set-customlineitem-taxrate"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`changeCustomLineItemQuantity`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#change-customlineitem-quantity"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#change-customlineitem-quantity"
              }}>{`✓`}</a></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`changeCustomLineItemMoney`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/carts#change-customlineitem-money"
              }}>{`✓`}</a></td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`-`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}><a parentName="td" {...{
                "href": "/api/../api/projects/order-edits#change-customlineitem-money"
              }}>{`✓`}</a></td>
          </tr>
        </tbody>
      </table>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      